/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { findLocationModalStyles } from "@monsma/Overrides/Components/FindLocationModal";
import { locationSearchFormStyles } from "@monsma/Overrides/Components/LocationSearchForm";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

findLocationModalStyles.modal = {
    sizeVariant: "large",
};

findLocationModalStyles.modalContent = {
    gap: 15,
};

findLocationModalStyles.leftColumnGridItem = {
    width: [12, 12, 6, 4, 4],
};

findLocationModalStyles.rightColumnGridItem = {
    width: [12, 12, 6, 8, 8],
};

findLocationModalStyles.searchGridContainer = {
    gap: 10,
};

findLocationModalStyles.searchTextField = {};

findLocationModalStyles.warehouseHoursModal = {
    sizeVariant: "small",
};

findLocationModalStyles.searchTextFieldGridItem = {
    width: 12,
    css: css`
        > div {
            margin-bottom: 25px;
        }
    `,
};

findLocationModalStyles.currentlySelectedGridContainer = {
    gap: 10,
};

findLocationModalStyles.currentlySelectedHeaderText = {
    size: 12,
    weight: 600,
    lineHeight: "18px",
};

findLocationModalStyles.searchResultsText = {
    size: 15,
    lineHeight: "22px",
    weight: "bold",
    css: css`
        .total-label {
            font-weight: normal;
        }
    `,
};

findLocationModalStyles.distanceUnitOfMeasureRadioGroup = {};

findLocationModalStyles.searchResultsTextGridItem = {
    width: 4,
    css: css`
        padding-bottom: 15px;
    `,
};

findLocationModalStyles.distanceUnitOfMeasureGridItem = {
    width: 8,
    css: css`
        justify-content: flex-end;
        padding-bottom: 15px;
    `,
};

findLocationModalStyles.siteMessageGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

findLocationModalStyles.searchResultGridItem = locationSearchFormStyles.searchResultGridItem;

findLocationModalStyles.searchResultGridContainer = {
    ...locationSearchFormStyles.searchResultGridContainer,
    css: css`
        ${locationSearchFormStyles.searchResultGridContainer?.css}
        > div {
            width: 100%;
        }
    `,
};

findLocationModalStyles.searchResultDisplayNumberGridItem = locationSearchFormStyles.searchResultDisplayNumberGridItem;

findLocationModalStyles.searchResultWarehouseGridItem = locationSearchFormStyles.searchResultLocationGridItem;

findLocationModalStyles.warehouseNameText = {
    ...locationSearchFormStyles.locationNameLink?.typographyProps,
    color: "common.ui2",
    css: locationSearchFormStyles.locationNameLink?.css,
};

findLocationModalStyles.searchResultAddressInfoGridItem = locationSearchFormStyles.searchResultAddressInfoGridItem;

findLocationModalStyles.warehouseAddressInfoCondensed = locationSearchFormStyles.locationAddressInfoCondensed;

findLocationModalStyles.searchResultDistanceGridItem = locationSearchFormStyles.searchResultDistanceGridItem;

findLocationModalStyles.warehouseDistanceDisplayText = locationSearchFormStyles.locationDistanceDisplayText;
findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem =
    locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem;

findLocationModalStyles.warehouseGoogleMapsDirectionLink = locationSearchFormStyles.locationGoogleMapsDirectionLink;

findLocationModalStyles.searchResultHoursGridItem = locationSearchFormStyles.searchResultContentGridItem;

findLocationModalStyles.warehouseHoursLink = locationSearchFormStyles.locationContentLink;

findLocationModalStyles.searchResultDividerGridItem = locationSearchFormStyles.searchResultDividerGridItem;

findLocationModalStyles.searchResultDivider = locationSearchFormStyles.searchResultDivider;

findLocationModalStyles.searchResultLinksOffsetGridItem = locationSearchFormStyles.searchResultPhoneOffsetGridItem;

findLocationModalStyles.searchResultPhoneGridItem = locationSearchFormStyles.searchResultPhoneGridItem;

findLocationModalStyles.searchResultPhoneLink = locationSearchFormStyles.searchResultPhoneLink;

findLocationModalStyles.searchResultSelectGridItem = {
    width: 11,
    css: css`
        padding-top: 10px;
    `,
};

findLocationModalStyles.paginationGridItem = locationSearchFormStyles.paginationGridItem;

findLocationModalStyles.selectedWarehouseGridContainer = {
    gap: 10,
};

findLocationModalStyles.selectedWarehouseDetailsGridItem = {
    width: [12, 8, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

findLocationModalStyles.selectedWarehouseNameText = findLocationModalStyles.warehouseNameText;

findLocationModalStyles.selectedWarehousePhoneLink = findLocationModalStyles.searchResultPhoneLink;

findLocationModalStyles.selectedWarehouseLinksGridItem = {
    width: [12, 4, 6, 6, 6],
    css: css`
        flex-direction: column;
        > * {
            margin-bottom: 10px;
        }
    `,
};

findLocationModalStyles.selectedWarehouseDistanceText = findLocationModalStyles.warehouseDistanceDisplayText;

findLocationModalStyles.selectedWarehouseGoogleMapsDirectionLink =
    findLocationModalStyles.warehouseGoogleMapsDirectionLink;

findLocationModalStyles.selectedWarehouseLink = findLocationModalStyles.warehouseHoursLink;

findLocationModalStyles.currentlySelectedDetailsGridItem = {
    width: 12,
    css: css`
        ${screen("gt", "sm")} {
            min-height: 110px;
        }
    `,
};
findLocationModalStyles.warehouseGoogleMap = {
    googleMap: {
        zoom: 14,
        mapContainerStyle: {
            height: "100%",
            minHeight: "435px",
            width: "100%",
        },
    },
};
